//
import React from "react";
//component
import SegmentLists from "./component/segment_lists";
import AudioUrl from "component/audio/audio_url";
import TriggerDetail from "./trigger/trigger_detail";
import DialogQCWarn from "./dialog/dialog_qc_warn";
import DialogQCDeny from "./dialog/dialog_qc_deny";
import {
  CheckOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Divider, Row } from "antd";
//redux
//selector
import {
  draftDialogAudioUrlSelector,
  draftDialogDetailSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
//actions
//utils
//hook
import { useSelector } from "react-redux";
import { useDialogQCClone } from "hook/draft/dialog/useDialogsQCClone";
//str

const SegmentDetail = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleOpenDeny, handleRatePass, handleOpenWarn } =
    useDialogQCClone();

  // const params = useParams();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const url = useSelector(draftDialogAudioUrlSelector);
  const data = useSelector(draftDialogDetailSelector);
  const rated = data?.rated || false;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderActions = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={8} lg={8} md={24} xs={24}>
          <Button
            loading={loading}
            onClick={handleRatePass}
            style={{ borderRadius: 5 }}
            disabled={rated}
            block
            icon={<CheckOutlined style={{ color: "green" }} />}
          >
            Đạt
          </Button>
        </Col>
        <Col xl={8} lg={8} md={12} xs={12}>
          <Button
            onClick={handleOpenWarn}
            style={{ borderRadius: 5 }}
            disabled={rated}
            block
            icon={<InfoCircleOutlined style={{ color: "orange" }} />}
          >
            Cảnh Cáo
          </Button>
        </Col>
        <Col xl={8} lg={8} md={12} xs={12}>
          <Button
            onClick={handleOpenDeny}
            style={{ borderRadius: 5 }}
            disabled={rated}
            block
            icon={<CloseOutlined style={{ color: "red" }} />}
          >
            Không Đạt
          </Button>
        </Col>
      </Row>
    );
  };

  const renderCard = () => {
    return (
      <Card style={{ marginTop: 30 }} size="small">
        <Row>
          <Col style={{ marginTop: 20 }} xl={24} lg={24} md={24} xs={24}>
            {renderActions()}
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <SegmentLists />
          </Col>
          <Divider plain>Nghe lại</Divider>
          <Col xl={24} lg={24} md={24} xs={24}>
            <AudioUrl url={url} />
          </Col>
        </Row>
      </Card>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Row justify={"center"} gutter={[0, 30]}>
      <Col align="center" xl={12} lg={12} md={22} xs={24}>
        <Row>
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderCard()}
          </Col>
        </Row>
      </Col>
      <DialogQCWarn />
      <DialogQCDeny />
      <TriggerDetail />
    </Row>
  );
};
export default SegmentDetail;
